import React from 'react';
import ReactDatePicker, { ReactDatePickerProps } from 'react-datepicker';

const DatePicker: React.FC<ReactDatePickerProps> = (props) => {
  return (
    <ReactDatePicker
      className="iva-date-picker"
      calendarClassName="iva-calendarClassName"
      clearButtonClassName="iva-clearButtonClassName"
      wrapperClassName="iva-wrapperClassName ui input"
      popperClassName="iva-popperClassName"
      {...props}
    />
  );
};

export default DatePicker;
